const DEFAULT_MAX_LENGTH = 1_000;
const REDACTED_SECRET = "[redacted secret]";
const REDACTED_CONTACT = "[redacted contact]";

const SENSITIVE_PATTERNS: readonly SensitivePattern[] = [
  {
    pattern: /authorization\s*:\s*bearer\s+[^\s,;]+/giu,
    replacement: "authorization: bearer [redacted]",
  },
  { pattern: /authorization\s*:\s*[^\s,;]+/giu, replacement: "authorization: [redacted]" },
  { pattern: /bearer\s+[a-z0-9._~+/=-]+/giu, replacement: "bearer [redacted]" },
  { pattern: /(cookie|set-cookie)\s*:\s*[^\n]+/giu, replacement: "$1: [redacted]" },
  {
    pattern: /(csrf|hmac|password|secret|token|api[_-]?key)\s*[:=]\s*[^\s,;]+/giu,
    replacement: `$1=${REDACTED_SECRET}`,
  },
  { pattern: /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/giu, replacement: REDACTED_CONTACT },
  { pattern: /\+?\d[\d ().-]{8,}\d/gu, replacement: REDACTED_CONTACT },
];

interface SensitivePattern {
  readonly pattern: RegExp;
  readonly replacement: string;
}

export function adminSafeDisplayText(
  value: string | null | undefined,
  fallback: string,
  maxLength = DEFAULT_MAX_LENGTH,
): string {
  const trimmed = value?.trim();
  if (trimmed === undefined || trimmed.length === 0) {
    return fallback;
  }

  return redactSensitiveText(trimmed).slice(0, maxLength);
}

export function adminSafeOptionalDisplayText(value: string | null | undefined): string | null {
  const safeValue = adminSafeDisplayText(value, "");
  return safeValue.length === 0 ? null : safeValue;
}

export function adminSafeErrorMessage(value: string | undefined, fallback: string): string {
  return adminSafeDisplayText(value, fallback, 500);
}

export function redactSensitiveText(value: string): string {
  return SENSITIVE_PATTERNS.reduce(
    (text, rule) => text.replace(rule.pattern, rule.replacement),
    value,
  );
}
